import React from 'react';
import { connect } from 'redux-bundler-react';

class SouthRegionTab extends React.Component {
  constructor(props){
    super(props);
    this.setActiveTab = this.setActiveTab.bind(this);
    this.closeTab = this.closeTab.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  setActiveTab(){
    const { idx, onSelect } = this.props;
    onSelect(idx);
  }

  closeTab(){  
    const { doCloseSouthTab, child } = this.props;
    doCloseSouthTab(child);
  }

  handleClick(e){
    const target = e.target;
    const { action } = target.dataset;
    switch(action){
      case 'nav':
        return this.setActiveTab();
      case 'close':
        return this.closeTab();
      default:
        return;
    }
  }

  render(){
    const { activeClass, displayName } = this.props;
    return (
      <li className={activeClass}>
        <span onClick={this.handleClick} className="pull-right" data-action="close" style={{padding: '10px 10px'}}>
          <i data-action="close" className="mdi mdi-close-circle-outline"></i>
        </span>
        <a onClick={this.handleClick} href="#" data-action="nav" style={{marginRight:'36px'}}>{displayName}</a>
      </li>
    )
  }
}

export default connect(
  'doCloseSouthTab',
  SouthRegionTab
)